import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.css']
})
export class GaugeChartComponent implements OnInit {
  @Input() index: any = 0;
  @ViewChild("gaugeChart", { static: true }) private gauge: ElementRef;
  @Input() gaugeData: any;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() { 
    if (this.gaugeData?.length) {
      setTimeout(() => {
        this._plotGraph();
      }, 0);
    }
  }

  private _plotGraph() {
    window.Plotly.newPlot(
      this.gauge?.nativeElement, //viewchild element
      this.gaugeData, {
      height: this.gaugeData[0]?.height,
      margin: { "l": 25, "r":25, "b": 0, "t": 0 },
      paper_bgcolor: "transparent",
      font: { color: "#1E1B39", family: "Inter" },
      template: {
        data: {
          indicator: [
            {
              mode: "gauge+number",
              delta: { reference: 90 },
              number: { suffix: this.gaugeData[0]?.suffix },
            }
          ]
        }
      },
      annotations: this.gaugeData[0]?.annotation
    },
      { //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: false,
      });
  }

}
